export const portfolioProjects = [
  {
    id: 1,
    title: 'Interpark 클론 코딩',
    description: '인터파크 클론 코딩',
    imageUrl: 'https://ticketimage.interpark.com/TicketImage/og/og_interparktour.png',
    tags: ['js', 'html', 'css'],
    link: 'https://www.notion.so/Interpark-Clone-21dd08a49cc381a3b7f0d8801c5b6820?source=copy_link',
  },
  {
    id: 2,
    title: 'ssgsag 클론 코딩',
    description: '슥삭 클론 코딩',
    imageUrl: 'https://www.ssgsag.kr/img_share.png',
    tags: ['js', 'html', 'css'],
    link: 'https://www.notion.so/Clone-coding-1-21dd08a49cc3817a8cdfd22bc1e59aec?source=copy_link',
  },
  {
    id: 3,
    title: 'mind diary',
    description: '마음일기 - 마인드 다이어리',
    imageUrl: 'https://moodi.co.kr/web/product/big/202411/4d1d935b6eefbde0ad3a6ed72f510115.jpg',
    tags: ['PRD', 'MVP', 'AI Prompt'],
    link: 'https://www.notion.so/21dd08a49cc3810384c3f6f83fa49773?source=copy_link',
  },
  {
    id: 4,
    title: 'dream diary',
    description: '꿈 다이어리',
    imageUrl: 'dream_in.png',
    tags: ['React', 'js', 'css'],
    link: 'https://www.notion.so/21dd08a49cc381d7b136f4052aff3518?source=copy_link',
  },
  {
    id: 5,
    title: 'portfolio',
    description: '문유비 포트폴리오',
    imageUrl: 'yubi_portfolio.png',
    tags: ['React', 'ts', 'tailwind'],
    link: 'ddodo',
  },
  {
    id: 6,
    title: 'Ddodo',
    description: 'todo-project (오늘 할 일)',
    imageUrl: 'ddodo.png',
    tags: ['React', 'ts', 'tailwind'],
    link: 'https://www.notion.so/Ddudoo-todo-project-256d08a49cc3805cbe9ac2c14d8fce11?source=copy_link',
  },
];
